export default "__VITE_ASSET__3GFv4sfP__"